import { forwardRef } from 'react'
import { formatDateReplaceHour } from 'src/utils/formatDate'
import { RestockingItemsList } from '../../RestockingTypes'
import Barcode from 'react-barcode'
import './print.css'

interface ListRestockingToPrintRepeatedlyProps {
  itemsList: RestockingItemsList
}
interface ListRestockingToPrintProps extends ListRestockingToPrintRepeatedlyProps {
  currentPage: number
}

const currentDateHour = new Date()

const currenteDate = currentDateHour.getDate()

const currentMonth = currentDateHour.getMonth() + 1

const currentYear = currentDateHour.getFullYear()

const currentHour = currentDateHour.getHours()

const currentMinutes = currentDateHour.getMinutes()

const currentSeconds = currentDateHour.getSeconds()

const dataHoraCompleta = `${currenteDate}/${currentMonth}/${currentYear} ${currentHour}:${currentMinutes}:${currentSeconds}`

const ListRestockingToPrint = forwardRef<HTMLDivElement, ListRestockingToPrintProps>(({ itemsList, currentPage }, ref) => (
  <div ref={ref} className='print-page'>
    <header className='header'>
      <p>FC {itemsList.idFulfillmentCenter} - REPOSIÇÃO {itemsList.type}</p>
      <p>REPOSIÇÃO {itemsList.sourceType} {itemsList.generatedCode}</p>
    </header>
    <div>
      <div className='container-data-restocking'>
        <div className='container-date-hour'>
          <h2 className='title'>REPOSIÇÃO {itemsList.sourceType} {itemsList.generatedCode}</h2>
          <p className='text'>Nome separação: _____________________________</p>
          <p className='text'>Data: ___/___/_____</p>
          <p className='text'>Hora: ___:___</p>
          <p className='text'>Turno: ________________________</p>
        </div>
        <div className='container-items-barcode'>
          <div className='container-items'>
            <p className='text'>Total SKUs: {itemsList.qtySku}</p>
            <p className='text'>Total de itens: {itemsList.totalItems}</p>
            <p className='text'>Horário atualização KDABRA:</p>
            <p className='text'>Nome conferente:</p>
          </div>
          <div className='barcode-list'>
            <Barcode
              value={String(itemsList.id).padStart(13, '0')}
              height={50}
              fontSize={13}
              format='CODE128'
            />
          </div>
        </div>
      </div>
      <div className='container-observations'>
        <p className='text'>Conferência da execução: __________________________________</p>
        <p className='text'>Ocorrências: _____________________________________________</p>
        <p className='text'>OBSERVAÇÃO: Essa folha pode passar por uma checagem de execução aleatória</p>
      </div>
      <table className='table'>
        <thead>
          <tr className='columns'>
            <th className='columns'><div className='div-column-model'>MODELO</div></th>
            <th className='columns'><div className='div-column-description'>SKU</div></th>
            <th className='columns'><div className='div-columns'>QTD P/ REPOR (UN)</div></th>
            <th className='columns'><div className='div-column-address-th'>RESERVA EXCEDENTE</div></th>
            <th className='columns'><div className='div-columns'>QTD RESERVA</div></th>
            <th className='columns'><div className='div-column-validate'>VALIDADE</div></th>
            <th className='columns'><div className='div-column-check'>CHECK</div></th>
            <th className='columns'><div className='div-columns'>QTD RETIRADA DA RESERVA</div></th>
            <th className='columns'><div className='div-columns'>QTD SOBROU NA RESERVA</div></th>
            <th className='columns'><div className='div-column-validate'>VALIDADE MÍNIMA</div></th>
            <th className='columns'><div className='div-column-address-th'>GÔNDOLA</div></th>
            <th className='columns'><div className='div-columns'>HORA DA MOV</div></th>
            <th className='columns'><div className='div-columns'>FEITO MOV NO KDABRA?</div></th>
          </tr>
        </thead>
        <tbody className='body-table'>
          {itemsList?.items.map((item, index) => {
            const addressArray: string[] = []
            const expirationDateArray: (Date | string)[] = []
            const quantityArray: (number | string)[] = []

            if (item.addresses.length > 0) {
              item.addresses.forEach((i) => {
                addressArray.push(i.address)
                expirationDateArray.push(i.expirationDate)
                quantityArray.push((i.quantity))
              })
            } else {
              addressArray.push('-')
              expirationDateArray.push('-')
              quantityArray.push('Sem reserva')
            }
            return (
              <tr key={index}>
                <td className='columns'><div className='div-column-model'>{item.productCode}</div></td>
                <td className='columns'><div className='div-column-description'>{item.productDescription}</div></td>
                <td className='columns'><div className='div-columns'>{item.restockQuantity}</div></td>
                <td className='columns'><div className='div-column-address-td'>{addressArray.map((address) => <> <span>{address}</span> <br/></>)}</div></td>
                <td className='columns'><div className='div-columns'>{quantityArray.map((quantity) => <> <span>{quantity}</span> <br/></>)}</div></td>
                <td className='columns'>{expirationDateArray.map((expirationDate) => {
                  if (typeof expirationDate === 'string' && Date.parse(expirationDate)) {
                    return <div className='div-column-validate'> <span>{formatDateReplaceHour(new Date(expirationDate))}</span> <br/></div>
                  }
                  return <p>{expirationDate}</p>
                })}
                </td>
                <td className='columns'><div className='div-column-check'> <span>&nbsp;</span></div></td>
                <td className='columns'><div className='div-columns'> <span>&nbsp;</span></div></td>
                <td className='columns'><div className='div-columns'> <span>&nbsp;</span></div></td>
                <td className='columns'><div className='div-column-validate'>{formatDateReplaceHour(item.minimumExpirationDate)}</div></td>
                <td className='columns'><div className='div-column-address-td'>{item.gondolaAddress}</div></td>
                <td className='columns'><div className='div-columns'> <span>&nbsp;</span></div></td>
                <td className='columns'><div className='div-columns'><input type='checkbox'/></div></td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
    <div className='footer'>
      <p>{dataHoraCompleta}</p>
      <p>{currentPage}</p>
    </div>
  </div>
))

function ListRestockingToPrintRepeatedly({ itemsList }: ListRestockingToPrintRepeatedlyProps) {
  const totalItems = itemsList.items.length
  const numRepetitions = Math.ceil(totalItems / 5)

  const renderings: any = []
  let currentPage = 1

  for (let i = 0; i < numRepetitions; i += 1) {
    const startRepetition = i * 5

    const endRepetition = Math.min(startRepetition + 5, totalItems)

    const repetitionItems = itemsList.items.slice(startRepetition, endRepetition)

    const restockListToPrint = { ...itemsList, items: repetitionItems }

    renderings.push(
      <div style={{ pageBreakBefore: 'always' }}>
        <ListRestockingToPrint key={i} itemsList={restockListToPrint} currentPage={currentPage} />
      </div>,
    )
    currentPage += 1
  }

  return <>{renderings}</>
}

export default ListRestockingToPrintRepeatedly
